import React from "react";
import { X } from "lucide-react";

const PdfViewerModal = ({
  pdfUrl,
  onClose,
  type = "a4"
}) => {

  const isTicket = type === "ticket";

  return (
    <div
      className="win-modal-overlay"
      style={{ zIndex: 10000 }}
    >

      <div
        className="win-modal-container"
        style={{
          width: isTicket ? "340px" : "85%",
          height: isTicket ? "90vh" : "90%",
          maxWidth: "100%",
          background: "#fff",
          display: "flex",
          flexDirection: "column"
        }}
      >

        {/* HEADER */}
        <div className="win-modal-header">

          <span>
            {isTicket
              ? "Visualizar Ticket"
              : "Visualizar Documento"}
          </span>

          <button
            className="win-close-btn"
            onClick={onClose}
          >
            <X size={16} />
          </button>

        </div>

        {/* BODY */}
        <div
          className="win-modal-body"
          style={{
            flex: 1,
            overflow: "hidden",
            background: "#f5f5f5"
          }}
        >

          <iframe
            src={pdfUrl}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{
              border: "none",
              background: "#fff"
            }}
          />

        </div>

      </div>

    </div>
  );
};

export default PdfViewerModal;